/** Keys returned by GET website-builder config `allowedFeatures` (mirrors backend). */
export const WEBSITE_BUILDER_UI_FEATURE_KEYS = [
  "pickup",
  "delivery",
  "curbside",
  "driveThru",
  "dineIn",
  "loyalty",
  "headerOrderControls",
]

export const filterWebsiteBuilderFeatureToggles = (toggles = [], allowedFeatures = null) => {
  if (!Array.isArray(allowedFeatures)) {
    return toggles
  }

  const allowed = new Set(allowedFeatures)
  return toggles.filter(item => allowed.has(item.key))
}
